import { Lookup } from './lookup';
import { ClientMajorShort } from './client-major-short';
import { StorySection } from './story-section';
import { CurrentCampaignStatus } from './current-campaign-status';

export class NewStudentOnboardingInfo {
    campaignId: number;
    activeStep: number;
    emailAddress: string;
    mobilePhone: string;
    yearInSchoolId: number;
    clientMajorId: number;
    layoutTemplateId: number;
    profileImageId: number;
    goalAmount: number;
    yearsInSchool: Lookup[];
    clientMajors: ClientMajorShort[];
    allowedEmailDomains: string;
    storySections: StorySection[];
    campaignEndDate: string;
    campaignStartDate: string;
    verifiedStudentId: string;
    initials: string;
    termsConsentDT: string;
    termsAccepted: boolean;
    // related to a campaign edit
    sponsors: number;
    canMoveToDraft: boolean;
    canMoveToActive: boolean;

    // For validating the max goal amount
    capAmount: number;
    updateGoal: boolean;

    isStepOneValid: boolean;
    isStepTwoValid = true; // Step 2 always valid since it's optional.
    isStepThreeValid: boolean;
    isStepFourValid: boolean;

    campaignStatus: CurrentCampaignStatus;

    /*
     * Compares this object to another and returns true if they have equal input values.
     */
    equals = (other: NewStudentOnboardingInfo): boolean => {
        return this.campaignId === other.campaignId
            && this.emailAddress === other.emailAddress
            && this.mobilePhone === other.mobilePhone
            && this.yearInSchoolId === other.yearInSchoolId
            && this.clientMajorId === other.clientMajorId
            && this.layoutTemplateId === other.layoutTemplateId
            && this.termsAccepted === other.termsAccepted
            && this.goalAmount === other.goalAmount
            && this.profileImageId === other.profileImageId
            && this.canMoveToActive === other.canMoveToActive
            && this.sponsors === other.sponsors
            && this.canMoveToDraft === other.canMoveToDraft
            && this.profileImageId === other.profileImageId
            && this.campaignStartDate === other.campaignStartDate
            && this.campaignEndDate === other.campaignEndDate
            && this.storySections.every((s, idx) => (s.studentAnswer || '') === (other.storySections[idx].studentAnswer || ''));
    }

    createCopy = (): NewStudentOnboardingInfo => {
        const copy = new NewStudentOnboardingInfo();

        copy.campaignId = this.campaignId;
        copy.emailAddress = this.emailAddress;
        copy.mobilePhone = this.mobilePhone;
        copy.yearInSchoolId = this.yearInSchoolId;
        copy.termsConsentDT = this.termsConsentDT;
        copy.termsAccepted = this.termsAccepted;
        copy.clientMajorId = this.clientMajorId;
        copy.layoutTemplateId = this.layoutTemplateId;
        copy.goalAmount = this.goalAmount;
        copy.yearsInSchool = this.yearsInSchool;
        copy.clientMajors = this.clientMajors;
        copy.allowedEmailDomains = this.allowedEmailDomains;
        copy.capAmount = this.capAmount;
        copy.updateGoal = this.updateGoal;
        copy.storySections = this.storySections.map(ss => ({ ...ss }));
        copy.campaignStartDate = this.campaignStartDate;
        copy.campaignEndDate = this.campaignEndDate;
        copy.isStepOneValid = this.isStepOneValid;
        copy.isStepTwoValid = this.isStepTwoValid;
        copy.isStepThreeValid = this.isStepThreeValid;
        copy.isStepFourValid = this.isStepFourValid;
        copy.profileImageId = this.profileImageId;
        copy.canMoveToDraft = this.canMoveToDraft;
        copy.canMoveToActive = this.canMoveToActive;
        copy.sponsors = this.sponsors;
        copy.campaignStatus = this.campaignStatus;

        return copy;
    }
}
